import { IContentBlock } from "contentful-types"
import React, { FC } from "react"
import { ContentfulContentProp } from "./shared-types"
import { DynamicContentMarkdown } from "components/dynamic-content/DynamicContentMarkdown"

// Does this have value being its own component? My guess is "no"

export const ContentBlock: FC<ContentfulContentProp<IContentBlock>> = ({ content }) => {
  const {
    fields: { body }
  } = content
  return <DynamicContentMarkdown source={body} />
}
